import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ItemOfferDetails from "./ItemOfferDetails";
import { setFidelityPhoneByFidelityId } from "../../../shared/requests-api";
import { CpfsExpiradosModal } from "../../../services/modals";
import { formatCurrency, intFormat } from "../../../../../js/shared/utils";
import { formatPhone } from "../../../shared/utils";
import { OfferColorStatus, OfferStatus, OfferSubStatus } from "../../../shared/enums";
import { editOffer, viewOffer, viewRanking, refreshOffers } from "../../../actions";
import Loading from "../../../../shared/Loading/Loading";
import { withGetScreen } from "react-getscreen";
import { ROUTE_RANKING, ROUTE_PREFIX_EDIT_OFFER } from "../../../shared/constants";
import {
	needRanking,
	showAverageHome,
	isRelationshipStatusActive,
	isRelationshipStatusPendentOrNegotiation
} from "../../../shared/utils";
import QuickSale from "./QuickSale";
import { logEvent } from "../../../shared/firebase";
import Button from "../../../../shared/button/button";
import CardTag from "../../atoms/card-tag";
import Callout from "../../../../shared/Callout/Callout";
import ModalLatamPhone from "../../../../shared/create-offer/ModalPhoneLatam/ModalLatamPhone";

class ItemListOffer extends Component {
	constructor() {
		super();

		this.state = {
			showDetails: false,
			hasManagementActive: false,
			hasRelationshipPendent: true,
			actionsMenu: false,
			isOpenEditPrice: false,
			showModalExpiredDocuments: false,
			showModalPhone: false,
			showCalloutAnalysis: false
		};

		this.view = this.view.bind(this);
		this.ranking = this.ranking.bind(this);
		this.hasActiveLink = this.hasActiveLink.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.handleOpenEditPrice = this.handleOpenEditPrice.bind(this);
	}

	hasActiveLink(props) {
		const { dataRelationshipParticipant } = props;

		// Valida se é um usuário com gestor com vinculo pra ignorar dados bancários
		let hasManagementActive =
			dataRelationshipParticipant &&
			dataRelationshipParticipant.some(re => isRelationshipStatusActive(re));

		// Vinculo pendente
		let hasRelationshipPendent =
			!hasManagementActive && // Se tiver vinculo ativo não precisa validar
			dataRelationshipParticipant &&
			dataRelationshipParticipant.some(re => isRelationshipStatusPendentOrNegotiation(re));

		this.setState({ hasManagementActive, hasRelationshipPendent });
	}

	UNSAFE_componentWillMount() {
		setTimeout(() => this.hasActiveLink(this.props), 500);
	}

	componentDidMount() {
		this.handleRank(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.handleRank(nextProps);
		this.hasActiveLink(nextProps);
	}

	handleRank(props) {
		const { offer } = props;

		this.setState({ saleState: undefined });
		if (offer && offer.quant) {
			let saleState;
			if (offer.rank < 10) {
				saleState = {
					phrase: "Venda rápida",
					color: "green"
				};
			} else if (offer.rank < 50) {
				saleState = {
					phrase: "Vai ter que esperar alguns dias",
					color: "orange"
				};
			} else {
				saleState = {
					phrase: "Venda lenta",
					color: "red"
				};
			}
			this.setState({
				saleState: saleState
			});
		}
	}

	edit() {
		const { offer, editOffer, history } = this.props;
		logEvent("edit_offer_button");
		window.scrollTo(0, 0);
		// Não mostrar mais aviso
		localStorage.setItem("SimulatorMilesAviso", "1");
		editOffer(offer);
		history.push(ROUTE_PREFIX_EDIT_OFFER);
	}

	view() {
		const { offer, viewOffer } = this.props;
		window.scrollTo(0, 0);
		viewOffer(offer);
	}

	ranking() {
		const { offer, viewRanking, history } = this.props;

		window.scrollTo(0, 0);
		history.push(ROUTE_RANKING);
		viewRanking(offer.fidelity.id);
	}

	handleActionsMenu = () => {
		// Adiciona e remove o evento para escutar o click fora do componente
		if (!this.state.actionsMenu) window.addEventListener("mousedown", this.handleClickOutside);
		else window.removeEventListener("mousedown", this.handleClickOutside);

		this.setState({
			actionsMenu: !this.state.actionsMenu
		});
	};

	handleClickOutside(event) {
		if (!this.actionsMenuInst.contains(event.target)) this.handleActionsMenu();
	}

	handleOpenEditPrice() {
		const { isOpenEditPrice } = this.state;
		this.setState({ isOpenEditPrice: !isOpenEditPrice });
	}

	setPhoneFidelity(value) {
		const { offer, refreshOffers } = this.props;
		let self = this;
		setFidelityPhoneByFidelityId(offer.fidelity.id, value).then(() => {
			offer.isMaxPhone = 1;
			offer.subStatusId = 0;
			offer.status = OfferStatus.EM_ANALISE;
			offer.statusText = "";
			self.setState({ showModalPhone: false, showCalloutAnalysis: true });
		});
	}

	render() {
		const {
			offer,
			lastItem,
			hasComponentQuickSaleActive,
			setComponentQuickSaleActive,
			edit,
			phoneMMSuggestion,
			typePhoneLatam
		} = this.props;
		const {
			showDetails,
			hasRelationshipPendent,
			isOpenEditPrice,
			showModalPhone,
			showCalloutAnalysis
		} = this.state;
		let hasQuickSaleActivedInWebView = hasComponentQuickSaleActive && lastItem && window.isWebview;
		const quickSale = () => (
			<QuickSale
				activeQuickSale={isOpenEditPrice && window.innerWidth < 768}
				offer={offer}
				hasRelationshipPendent={hasRelationshipPendent}
				hasComponentQuickSaleActive={hasComponentQuickSaleActive}
				setComponentQuickSaleActive={setComponentQuickSaleActive}
				edit={edit}
				handleOpenEditPrice={this.handleOpenEditPrice}
			/>
		);

		const fixNumberButton = () => (
			<Button
				onClick={() => this.setState({ showModalPhone: true })}
				className={`btn btn-green-clean ${window.isMobileDevice() ? " fix-number-button-mobile" : " fix-number-button"
					}`}
				data-action="update-latam-phone-show-modal"
			>
				Corrigir número
			</Button>
		);

		const quantityMiles = () => (
			<>
				<p className="quantity-miles">
					{latamInativeWrongPhone && typePhoneLatam === 0
						? "Corrija e ganhe até:"
						: `${intFormat(offer.quant)} milhas`}
				</p>
				<p className="quantity-miles--total">
					<small>R$</small>
					{formatCurrency(offer.total, " ")}
				</p>
				{latamInativeWrongPhone && typePhoneLatam === 0 ? (
					<p className="quantity-miles no-padding">ao concluir a venda</p>
				) : (
					<p className="average-miles" style={showAverageHome(offer) ? {} : { display: "none" }}>
						Média: {intFormat(offer.averageMiles || 0) + " "}milhas
					</p>
				)}
			</>
		);

		const isEditableOrRemoveOffer = () => {
			return offer.editable || offer.removeOffer || offer.expiredDocuments > 0;
		};

		const isWrongMaxPhone = () => offer.isMaxPhone === 0 || offer.isMaxPhone === -1;

		const forcedPendentLatamPhone =
			offer.idairlines === 1 &&
			(offer.subStatusId === OfferSubStatus.REANALISE_PENDENCIA_OFERTA ||
				offer.subStatusId === OfferSubStatus.ATIVO_LIBERADO) &&
			isWrongMaxPhone();

		const latamInativeWrongPhone =
			offer.idairlines === 1 &&
			(offer.subStatusId === OfferSubStatus.INATIVO_TELEFONE_LATAM || forcedPendentLatamPhone);

		return (
			<div className="col-xs-16 no-padding">
				<div
					className={`col-xs-16 item-list-offer ${offer.sales && offer.sales.length > 0 ? "has-details" : ""
						} ${hasQuickSaleActivedInWebView ? "item-list-offer--webview" : ""}`}
				>
					<div
						className={`col-xs-16 item-list-offer--box${latamInativeWrongPhone && typePhoneLatam === 0 ? " error-border" : ""
							}`}
					>
						<div className="card-header">
							<div className={`${window.isMobileDevice() ? 'col-xs-14' : 'col-xs-12'} col-sm-9 no-padding`}>
								<span className="text-left no-padding fidelity-name">
									<span>{offer.fidelity.name}</span> - {offer.fidelity.airlineAcronym}
								</span>
								<p className="text-left no-padding offer-status">
									<i
										className={`dot dot-${latamInativeWrongPhone && typePhoneLatam === 0
											? "red"
											: OfferColorStatus[offer.status]
											}`}
									/>
									{OfferStatus[offer.status]}
									{offer.statusText && <span className="status-text"> - {offer.statusText}</span>}
								</p>
							</div>
							{isEditableOrRemoveOffer() &&
								(window.isMobileDevice() ? (
									<div className="col-xs-2 col-ms-7 no-padding item-list-offer--overflow">
										{offer.expiredDocuments > 0 && (
											<Button
												onClick={() => this.setState({ showModalExpiredDocuments: true })}
												className="item-list-offer--expired-documents"
												data-action="expired-documents-show-modal"
											>
												{offer.expiredDocuments}
											</Button>
										)}
										<Button
											type="button"
											onClick={this.handleActionsMenu}
											className="item-list-offer--overflow--buttons--actions-menu-button"
										>
											<i className="icon-max-action-overflow" />
										</Button>
										{this.state.actionsMenu && (
											<div className="actions-menu" ref={inst => (this.actionsMenuInst = inst)}>
												{offer.editable && (
													<div
														className="actions-menu--button--edit"
														onClick={offer.editable ? () => edit(offer) : undefined}
														data-action="item-list-offer-edit"
													>
														<i className="icon-max-action-edit" />
														<span>Editar oferta</span>
													</div>
												)}
												{offer.removeOffer && (
													<div
														className="actions-menu--button--delete"
														onClick={
															offer.editable
																? () => (this.handleActionsMenu(), this.props.onDelete(offer))
																: undefined
														}
														data-action="item-list-offer-delete"
													>
														<i className="icon-max-action-delete" />
														<span>Remover oferta</span>
													</div>
												)}
											</div>
										)}
									</div>
								) : (
									<div className="col-xs-4 col-sm-7 no-padding item-list-offer--actions">
										<ul>
											{offer.expiredDocuments > 0 && (
												<li
													onClick={() => this.setState({ showModalExpiredDocuments: true })}
													className="item-list-offer--expired-documents"
													data-action="expired-documents-show-modal"
												>
													{offer.expiredDocuments}
												</li>
											)}
											{offer.editable && (
												<li
													onClick={offer.editable ? () => edit(offer) : undefined}
													data-action="item-list-offer-edit"
												>
													Editar
												</li>
											)}
											{offer.removeOffer && (
												<li
													onClick={offer.removeOffer ? () => this.props.onDelete(offer) : undefined}
													data-action="item-list-offer-delete"
												>
													Remover
												</li>
											)}
										</ul>
									</div>
								))}
						</div>
						<div className="col-xs-16 offers-divider" />
						{window.isMobileDevice() ? (
							<div className="col-xs-16 card-details">
								{!!latamInativeWrongPhone && typePhoneLatam === 0 && (
									<div className="col-xs-16 no-padding text-left offers-divider">
										<p className="registered-phone">Telefone cadastrado:</p>
										<p className="registered-phone--number">{formatPhone(offer.phone)}</p>
									</div>
								)}
								<div
									className={`${latamInativeWrongPhone && typePhoneLatam === 0 ? "col-xs-16" : "col-xs-9"
										} text-left no-padding card-details--info-tag`}
								>
									<div>{quantityMiles()}</div>
									<CardTag show={offer.type == 2} color="blue">
										Venda rápida
									</CardTag>
									<CardTag show={offer.type == 3} color="orange">
										Revenda
									</CardTag>
									<CardTag show={offer.type == 4} color="orange">
										Agendado
									</CardTag>
									<CardTag show={offer.hasBonus} color="dark">
										Bônus
									</CardTag>
								</div>
								{latamInativeWrongPhone && typePhoneLatam === 0 ? (
									<>
										<div className="col-xs-16 no-padding">{fixNumberButton()}</div>
									</>
								) : (
									<>
										<div className="col-xs-7 no-padding card-details--info-edit">
											<div className="thousand-price-area-mobile">
												<p className="thousand-price-area-mobile--text">Mil milhas por:</p>
												<p className="thousand-price-area-mobile--value">
													<span>R$</span> {formatCurrency(offer.price, " ")}
												</p>
											</div>
											{offer.editable && offer.allowsFastPrices && (
												<div
													onClick={() => this.setState({ isOpenEditPrice: !isOpenEditPrice })}
													className={`edit-button-mobile edit-button-mobile--${isOpenEditPrice ? "opened" : "closed"
														}`}
												>
													<span>Editar preço</span>
													<i className={isOpenEditPrice ? "icon-arrow-up" : "icon-arrow-down"} />
												</div>
											)}
										</div>
										{isOpenEditPrice && (
											<div className="col-xs-16 no-padding">
												<div
													className={`col-xs-16 quick-sale-area-mobile no-padding ${isOpenEditPrice ? "opened" : "closed"
														}`}
												>
													{quickSale()}
												</div>
											</div>
										)}
									</>
								)}
							</div>
						) : (
							<div className="col-xs-16 card-details">
								<div
									className={`${latamInativeWrongPhone && typePhoneLatam === 0 ? "col-xs-7" : "col-xs-9"
										} text-left no-padding card-details--info-tag`}
								>
									<div>{quantityMiles()}</div>
									<CardTag show={offer.type == 2} color="blue">
										Venda rápida
									</CardTag>
									<CardTag show={offer.type == 3} color="orange">
										Revenda
									</CardTag>
									<CardTag show={offer.type == 4} color="orange">
										Agendado
									</CardTag>
									<CardTag show={offer.hasBonus} color="dark">
										Bônus
									</CardTag>
								</div>

								{latamInativeWrongPhone && typePhoneLatam === 0 ? (
									<>
										<div className="col-xs-3 no-padding">
											<p className="registered-phone">Telefone cadastrado:</p>
											<p className="registered-phone--number">{formatPhone(offer.phone)}</p>
										</div>
										<div className="col-xs-6 no-padding">{fixNumberButton()}</div>
									</>
								) : (
									offer.type !== 3 &&
									offer.allowsFastPrices && (
										<div className="col-xs-7 no-padding">
											<div className="thousand-price-area">{quickSale()}</div>
										</div>
									)
								)}
							</div>
						)}
						{offer.idairlines === 1 && offer.editable && typePhoneLatam === 0 && (
							<>
								<div className="col-xs-16 item-list-offer--callout">
									{offer.isMaxPhone === 0 ? (
										<Callout
											show={true}
											criticalWarn
											text={
												<span>
													<strong>
														Atenção! É obrigatório adicionar o número de telefone celular da
														MaxMilhas no seu cadastro Latam Pass. Para alterar,&nbsp;
													</strong>
													<Button
														onClick={() => this.setState({ showModalPhone: true })}
														className="item-list-offer--link"
													>
														<strong>Clique aqui.</strong>
													</Button>
												</span>
											}
										/>
									) : (
										offer.isMaxPhone === -1 && (
											<Callout
												show={true}
												criticalWarn
												text={
													<span>
														<strong>
															Este número foi desativado e deve ser alterado para o telefone
															indicado pela MaxMilhas.
														</strong>
														<Button
															onClick={() => this.setState({ showModalPhone: true })}
															className="item-list-offer--link"
														>
															<strong> Clique aqui.</strong>
														</Button>
													</span>
												}
											/>
										)
									)}
									{showCalloutAnalysis && offer.isMaxPhone === 1 && (
										<Callout
											show={true}
											success
											text={
												<span>
													<strong>
														Pronto! Recebemos sua oferta e nosso time irá analisar em breve.
													</strong>
												</span>
											}
										/>
									)}
								</div>
								<ModalLatamPhone
									show={showModalPhone}
									close={() => this.setState({ showModalPhone: false })}
									confirm={value => {
										this.setState({ showModalPhone: false, showCalloutAnalysis: true });
										this.setPhoneFidelity(value);
									}}
									phoneSugestion={phoneMMSuggestion}
									phone={offer.phone ?? ""}
									updateLatamPhone
								/>
							</>
						)}
					</div>

					{offer.sales && offer.sales.length > 0 && (
						<div className={`item-list-offer__details-button ${showDetails ? "opened" : ""}`}>
							<button
								className="btn btn-icon"
								onClick={() => this.setState({ showDetails: !showDetails })}
								data-action="item-list-offer-expand-collapse"
							>
								<i className="icon-arrow-down" />
							</button>
						</div>
					)}
				</div>
				{showDetails && (
					<div className="item-offer-details" style={{ maxHeight: showDetails ? "1000px" : "0px" }}>
						<ItemOfferDetails offer={offer} />
					</div>
				)}

				{this.state.showModalExpiredDocuments && (
					<CpfsExpiradosModal
						show={this.state.showModalExpiredDocuments}
						onCancel={() => this.setState({ showModalExpiredDocuments: false })}
						onConfirm={offer.editable ? () => edit(offer) : undefined}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	offersRank: state.offers.ranks,
	dataRelationshipParticipant: state.accountLink.dataRelationshipParticipant
});

const mapDispatchToProps = dispatch => {
	return {
		editOffer: offer => dispatch(editOffer(offer)),
		viewOffer: offer => dispatch(viewOffer(offer)),
		viewRanking: id => dispatch(viewRanking(id)),
		refreshOffers: () => dispatch(refreshOffers())
	};
};

export default withRouter(
	withGetScreen(connect(mapStateToProps, mapDispatchToProps)(ItemListOffer), {
		mobileLimit: 468, // TODO Fix screen vars
		tabletLimit: 768, // TODO Fix screen vars
		shouldListenOnResize: true
	})
);
